import React, { useEffect, useState } from "react";
import { SET_GAME_BONUS_RESULT_POST } from "../../api/ApiConst";
import { callPostApi } from "../../api/ApiCaller";
import { getFormattedAmountWithDenomination } from "../../utils/TextUtils";
import $ from "jquery";


let interactionDisabled = false;
let apiCallflag = false

let DEFAULT_IMAGE = "./assets/img/poolSpin/bol0.PNG";
let ROLL_IMAGE = "./assets/img/poolSpin/roll.gif";
let IMAGE_PATH = "./assets/img/poolSpin/bol";

function PoolSpinBonus({ keyboardInput, gameSessionRecordId, onBonusRoundCompleted, walletBalance, denomination, gameResult }) {
    const [images, setImages] = useState(Array(3).fill("./assets/img/poolSpin/bol0.PNG"));
    const [isRolling, setIsRolling] = useState(false);
    const [apiData, setApiData] = useState(null);
    const [bonusWonAmount, setBonusWonAmount] = useState(0);
    const [totalWinAmount, setTotalWinAmount] = useState(0)
    const [bonusMultiplyAmnt, setbonusMultiplyAmnt] = useState(0)


    
    useEffect(() => {

        const payload = {
            bonusType: "Bonus06PoolSpinsLightWitch",
            recordId: gameSessionRecordId,
        };
        if (!apiCallflag) {
            apiCallflag = true;

            callPostApi(SET_GAME_BONUS_RESULT_POST, payload, {}, (response) => {
                let res = response?.responsePacket;
                let bonusMultiplier = res?.bonusDetails?.bonusMultiplier;
                setbonusMultiplyAmnt(bonusMultiplier);
                if (res) {
                    setApiData(res);
                } else {
                    console.error("API Call Failed:", response?.errorMessage || "Unknown error");
                }
            })
        }
    }, []);



    useEffect(() => {
        const handleKeyPress = (event) => {
            const key = event.key.toLowerCase();
            if (key == "b") {
                handleGameStart()
            }
        };

        if (keyboardInput && apiData) {
            window.addEventListener("keydown", handleKeyPress);
            return () => {
                window.removeEventListener("keydown", handleKeyPress);
            };
        }


    }, [keyboardInput, gameSessionRecordId,apiData]);

    const playSoundById = (soundTagId) => {
        let sound = $("#" + soundTagId)[0];
        if (sound) {
            sound.currentTime = 0;
            sound.play();
        }
    };
    const pauseSoundById = (soundTagId) => {
        let sound = $("#" + soundTagId)[0];
        if (sound) {
            sound.pause();
            sound.currentTime = 0;
        }
    };

    const extractDigits = (ballNumbers) => {
        return ballNumbers.split("").map(Number);
    }

    const handleGameStart = () => {
        if (interactionDisabled || isRolling) return;

        interactionDisabled = true;
        setIsRolling(true);
        setImages(Array(3).fill(ROLL_IMAGE));

        playSoundById('poolSpinShot')

        let res = apiData;
        let ballNumbers = res?.bonusDetails?.ballNumber;
        let gameTotalWin = res?.totalWinnings;
        let poolBonusWin = res?.totalBonusWinnings;

        let digits = extractDigits(ballNumbers);

        setTimeout(() => {
            setImages(digits.map((digit) => `${IMAGE_PATH}${digit}.PNG`));
            setIsRolling(false);
            pauseSoundById("poolSpinShot");
            playSoundById("poolSecondAudio");
            setBonusWonAmount(poolBonusWin);
            setTotalWinAmount(gameTotalWin);

            if (gameTotalWin >= 0) {
                setTimeout(() => {
                    onBonusRoundCompleted(gameTotalWin);
                    interactionDisabled = false;
                    apiCallflag = false;
                }, 4000);
            }
        }, 3000);
    };


    const loadStaticAudio = () => {
        return (
            <>
                <div style={{ display: "none" }}>
                    <audio controls="" id="poolSpinShot" className="audioFile">
                        <source src="assets/poolSpinShot.mp3" type="audio/mpeg" />
                    </audio>
                    <audio controls="" id="poolSecondAudio" className="audioFile">
                        <source src="assets/poolSecondAudio.mp3" type="audio/mpeg" />
                    </audio>
                </div>
            </>
        );
    };


    return (
        <>
            <div className="h-100 w-100 position-relative bg-black">
                <div className="contentPosition p-0">
                    <div className="cauldron-content bg-transparent ">
                        <div className="cauldron-inner-content">
                            <div className="text-center position-relative h-50">
                                <img className="w-100 position-absolute h-100 start-0 end-0" src="./assets/img/poolSpin/sec-top.png" alt="" />
                            </div>
                            <div className="bg-black h-100 poolSpin-row py-3">
                                <div className="poolSpin-col">
                                    <img src="./assets/img/poolSpin/jogador.gif" alt="" />
                                </div>
                                <div className="poolSpin-col">
                                    <img src="./assets/img/poolSpin/triangulo.gif" alt="" />
                                </div>
                                <div className="poolSpin-col">
                                    <img src="./assets/img/poolSpin/taco.gif" alt="" />
                                </div>
                                <div className="poolSpin-col">
                                    <img src="./assets/img/poolSpin/mesa.gif" alt="" />
                                </div>
                            </div>
                            <div className=" position-relative h-50 ">
                                <img className="w-100 h-100 position-absolute start-0 end-0" src="./assets/img/poolSpin/sec-middle.png" alt="" />

                                <div className="w-100 h-100 position-absolute start-0 end-0 z-1 d-flex">
                                    <div className="w-25"></div>
                                    <div className="w-50 font-value text-start"><font>{bonusMultiplyAmnt}</font></div>
                                    <div className="w-25 font-value text-start"><font className="p-0">{bonusWonAmount}</font></div>
                                </div>

                            </div>
                            <div className="bg-black h-100 py-3 ">
                                <div className="spin-roll-section d-flex align-items-center justify-content-center">
                                    {images.map((src, index) => (
                                        <div key={index} id="parentDiv" className="box-col position-relative">
                                            <img src={src} alt={`ball-${index}`} className={`spin-image ${isRolling ? "new-class" : ""}`}
                                                onClick={() => {
                                                    if (!interactionDisabled) {
                                                        handleGameStart();
                                                    }
                                                }}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="position-relative h-50">
                                <img className="w-100 h-100 position-absolute start-0 end-0" src="./assets/img/poolSpin/sec-bottom.png" alt="" />
                                <img className="w-100 h-100 position-absolute start-0 end-0" src="./assets/img/poolSpin/sec-bottom.png" alt="" />
                                <div className="w-100 h-100 position-absolute start-0 end-0 z-1 d-flex">
                                    <div className="w-25"></div>
                                    <div className="w-50 font-value text-start"><font>{getFormattedAmountWithDenomination(walletBalance, denomination)}</font></div>
                                    <div className="w-25"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {loadStaticAudio()}
        </>
    );
}

export default PoolSpinBonus;
